module.exports = __webpack_public_path__ + "static/sahil-d5fb8ab4c1c1638b18cfc97505e780a8.jpg";